// project import
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from '~/hooks/useAuth';
// types
import { GuardProps } from '~/types/auth';

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }: GuardProps) => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoggedIn) {
      // navigate to register firs if user comes from Topstep.com (CMS)
      const urlParams = new URLSearchParams(location.search);
      const isFromCms = urlParams.get('origin') === 'cms';

      navigate(isFromCms ? 'register' : 'login', {
        state: {
          from: location.pathname + location.search + location.hash,
        },
        replace: true,
      });
    }
  }, [isLoggedIn, navigate, location]);

  if (!isLoggedIn) return null;
  return children;
};

export default AuthGuard;
